// client/src/pages/datasets/DataSetActionsManage.js
import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SmartDataTable from "../../components/SmartDataTable";

export default function DataSetActionsManage() {
  const { datasetId } = useParams();
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      { label: "#", type: "count", value: "__count", width: "48px", align: "center" },
      { label: "Name", value: "name", search: "name", width: "220px" },
      { label: "Type", value: "type", search: "type", width: "140px" },
      { label: "Landing Page", value: "landingPageName", search: "landingPageName", width: "220px" },
      { label: "Card Design", value: "cardDesignName", search: "cardDesignName", width: "220px" },
      {
        label: "Status",
        value: "status",
        width: "60px",
        type: "render",
        render: (r) => (r.status === "active" ? "Active" : "Inactive"),
      },
      { value: 'printerNames', label: 'Printers', type: 'render', render: r => (r.printerNames?.length ? r.printerNames.join(', ') : '—') },
      {
        label: "Updated",
        value: "updatedAt",
        width: "160px",
        type: "render",
        render: (r) => (r.updatedAt ? new Date(r.updatedAt).toLocaleString() : ""),
      },
    ],
    []
  );

  const config = {
    pageTitle: "Dataset Actions",
    queryName: "/actions/listByDataSet",
    pageSize: 20,
    buttons: [
      { label: "Edit", class: "btn-edit", action: "/actions/edit/{_id}" },
      { label: "Delete", class: "btn-danger", action: "delete" },
    ],
    fixedFilters: { datasetId },
    deletePathTemplate: "/actions/delete/{_id}",
    deleteMethod: "POST",
    headerActions: (
      <>
        <button
          className="btn-return add-new-button"
          onClick={() => navigate("/datasets")}
        >
          Return
        </button>

        <button
          className="btn-save add-new-button"
          onClick={() =>
            navigate(`/actions/add?datasetId=${encodeURIComponent(datasetId)}`)
          }
        >
          Add New Action
        </button>
      </>
    ),
  };

  return (
    <div className="datatable-page">
      <div className="datatable-header-row" style={{ justifyContent: "space-between" }}>
        <div style={{ fontSize: 18, fontWeight: 700, paddingLeft: 20 }}>
          Dataset Actions
        </div>
      </div>

      <SmartDataTable
        key={`edit-actions-${datasetId}`}
        config={config}
        columns={columns}
        resetOnMount={true}
      />
    </div>
  );
}
